import { connect } from 'react-redux';
import ReplyHelp from 'Components/Help/ReplyHelp';
import { HelpAction } from 'Actions';

function mapStatetoProps(state){
    const { formLoading, errorElement, error } = state.help
    return{
        formLoading,
        errorElement,
        error,
    } 
}
const mapDispatchtoProps = {
    updateHelp: HelpAction.updateHelp,
}

export default connect(mapStatetoProps,mapDispatchtoProps)(ReplyHelp)